import {
	EDiloCreateResultDTO,
	EDiloFinanceResultDTO,
	EDiloLimitStatus,
	EDiloLimitsDTO,
} from '@FW/features/eDilo/api/eDilo.dto.types';
import {
	IEDiloCreateResult,
	IEDiloFinanceResult,
	IEDiloLimits,
} from '@FW/features/eDilo/api/eDilo.types';

const EDILO_LIMIT_STATUSES: EDiloLimitStatus[] = ['prelimit', 'approved', 'rejected'];

const normalizeStatus = (status: EDiloLimitStatus | ''): EDiloLimitStatus | null =>
	EDILO_LIMIT_STATUSES.includes(status as EDiloLimitStatus) ? (status as EDiloLimitStatus) : null;

export const eDiloLimitsAdapter = (dto: EDiloLimitsDTO): IEDiloLimits => ({
	available: dto.ДоступныйЛимит,
	total: dto.Полныйлимит,
	used: dto.ИспользованыйЛимит,
	status: normalizeStatus(dto.СтатусЛимита),
});

export const eDiloCreateResultAdapter = (dto: EDiloCreateResultDTO): IEDiloCreateResult => ({
	document: dto.DOCUMENT,
	link: dto.Ссылка_еДело,
});

export const eDiloFinanceResultAdapter = (dto: EDiloFinanceResultDTO): IEDiloFinanceResult => ({
	link: dto.Ссылка_еДело,
});
